var map = {
	"./icon-arrow.svg": 95361,
	"./icon-change.svg": 84134,
	"./icon-close.svg": 15686,
	"./icon-copy.svg": 38385,
	"./icon-edit.svg": 87038,
	"./icon-lfg.svg": 4015,
	"./icon-lock.svg": 69523,
	"./icon-ok.svg": 63480,
	"./icon-refresh.svg": 30303,
	"./icon-telegram.svg": 29611,
	"./upload-filled.svg": 7190
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48202;